/* eslint-disable no-param-reassign */
import axios from "axios";
import Store from "./store";
import { setPCTokenExpired } from "./features/userSlice";

const authorizedAxios = axios.create();
// Add a request interceptor
authorizedAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken"); // Fetch the JWT token
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error || "Request interceptor error"));
  }
);

authorizedAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const expiryHandlingInProgress = Store.getState().user.hasPCTokenExpired;
    if (Number(error.response.status) === 401 && !expiryHandlingInProgress) {
      Store.dispatch(setPCTokenExpired(true));
    }
    return Promise.reject(new Error(error || "Response interceptor error"));
  }
);

export default authorizedAxios;
